import React from 'react'
import DoneIcon from '../../icons/DoneIcon'
import DoingIcon from '../../icons/DoingIcon'

export const TestElem = ({index,classes, children,onClick,el}) => {
  return (
   <div className={classes.wrapper_element}>
      <div  className={ el.isFinished == 1 ? classes.element_finished : classes.element_started } data-elid={el.id} onClick={(e) => onClick(e.target,el.id,index)}>
         <div className={classes.icon_wrapper}>
            {
               el.conversationId?.level?.name ? 
               <p className={` ${classes.level} ${ classes[el.conversationId?.level?.name]} `}>{el.conversationId?.level?.name}</p>
               :
               ''
            }
            
            {children}
            <p className={classes.element_name}>{el.conversationId.name}</p>
            {
               el.isFinished == 1?
               (
                  <DoneIcon classes={classes} />
               ) 
               : 
               (
                  <DoingIcon className={classes.continue_icon} />
               )
            }
         </div>
         <div>
            
            <p className={classes.description}>{el.conversationId.description}</p>
         </div>
      
      
      </div>
   </div>
  )
}
